/**
 * Kazakh strings. This file is the reference set, structurally and not only by convention:
 * `Translation` is derived from it, so a key added here and not to `ru.ts` fails the build.
 */
export const kk = {
    'brand.name': 'Ипотекалық дәрігер',

    'nav.home': 'Басты бет',
    'nav.portal': 'Жеке кабинет',
    'nav.sign_in': 'Кіру',
    'nav.sign_out': 'Шығу',
    'nav.language': 'Тіл',
    'nav.book': 'Жазылу',
    'nav.open_menu': 'Мәзірді ашу',
    'nav.close_menu': 'Мәзірді жабу',

    'home.title': 'Ипотека бойынша сенімді серіктесіңіз',
    'home.subtitle':
        'Біз ипотека алу жолын жеңілдетеміз: банк бағдарламаларын таңдау, есептеу және құжаттарды дайындау.',
    'home.contact_us': 'Хабарласу',
    'home.portal_cta': 'Жеке кабинетке кіру',
    'home.contacts': 'Байланыс',
    'home.phone': 'Телефон',
    'home.email': 'Электрондық пошта',
    'home.address': 'Мекенжай',
    'home.working_hours': 'Жұмыс уақыты',
    'home.whatsapp': 'WhatsApp',

    'theme.to_dark': 'Қараңғы режимге ауысу',
    'theme.to_light': 'Жарық режимге ауысу',

    'auth.aside.title': 'Ипотекаға дейінгі жолыңыз — бір экранда',
    'auth.aside.point1': 'Ісіңіздің қай кезеңде екенін және келесі қадам қандай екенін көресіз',
    'auth.aside.point2': 'Барлық құжаттарыңыз бір жерде сақталады',
    'auth.aside.point3': 'Кеңесшіңізге тікелей сұрақ қоясыз',

    'auth.sign_in.title': 'Жеке кабинетке кіру',
    'auth.sign_in.subtitle': 'Кеңесшіңізге берген электрондық пошта мекенжайын, телефон нөмірін немесе ЖСН-іңізді енгізіңіз.',
    'auth.sign_in.identifier': 'Пошта, телефон немесе ЖСН',
    'auth.sign_in.identifier_hint': 'Электрондық пошта, телефон нөмірі немесе ЖСН',
    'auth.sign_in.identifier_invalid': 'Электрондық поштаны, телефон нөмірін немесе ЖСН-ді енгізіңіз',
    'auth.sign_in.recognised': 'Анықталды:',
    'auth.sign_in.kind.email': 'электрондық пошта',
    'auth.sign_in.kind.phone': 'телефон нөмірі',
    'auth.sign_in.kind.iin': 'ЖСН',
    'auth.sign_in.password': 'Құпиясөз',
    'auth.sign_in.submit': 'Кіру',
    'auth.sign_in.no_account': 'Тіркелгіңіз жоқ па?',
    'auth.sign_in.register': 'Тіркелу',

    'auth.register.title': 'Тіркелу',
    'auth.register.subtitle': 'Жеке кабинет ашу үшін деректеріңізді енгізіңіз.',
    'auth.register.first_name': 'Аты',
    'auth.register.last_name': 'Тегі',
    'auth.register.phone': 'Телефон нөмірі',
    'auth.register.phone_hint': 'Жеке кабинетке осы нөмірмен кіресіз.',
    'auth.register.phone_invalid': 'Қазақстандық телефон нөмірін енгізіңіз',
    'auth.register.iin': 'ЖСН (міндетті емес)',
    'auth.register.iin_hint': 'Бір рет енгізіледі және кейін өзгертілмейді.',
    'auth.register.iin_invalid': 'ЖСН дұрыс емес',
    'auth.register.email': 'Электрондық пошта (міндетті емес)',
    'auth.register.email_hint': 'Көрсетсеңіз, электрондық пошта арқылы да кіре аласыз.',
    'auth.register.password': 'Құпиясөз',
    'auth.register.confirm_password': 'Құпиясөзді қайталаңыз',
    'auth.register.submit': 'Тіркелу',
    'auth.register.have_account': 'Тіркелгіңіз бар ма?',

    'auth.activate.title': 'Құпиясөз орнату',
    'auth.activate.subtitle': 'Жеке кабинетті іске қосу үшін жаңа құпиясөз ойлап табыңыз.',
    'auth.activate.password': 'Жаңа құпиясөз',
    'auth.activate.confirm_password': 'Құпиясөзді қайталаңыз',
    'auth.activate.submit': 'Сақтап, кіру',
    'auth.activate.mismatch': 'Құпиясөздер сәйкес келмейді.',
    'auth.activate.too_short': 'Құпиясөз кемінде 8 таңбадан тұруы керек.',
    'auth.activate.missing_link': 'Сілтеме толық емес. Кеңесшіңізден жаңа сілтеме сұраңыз.',
    'auth.activate.success': 'Құпиясөз орнатылды. Енді кіре аласыз.',

    'portal.title': 'Жеке кабинет',
    'portal.welcome': 'Қош келдіңіз',
    'portal.empty': 'Әзірге көрсетілетін іс жоқ. Сұрағыңыз болса, бізге жазыңыз немесе қоңырау шалыңыз.',
    'portal.loading': 'Жүктелуде…',

    'portal.cases': 'Менің істерім',
    'portal.case_number': 'Іс нөмірі',
    'portal.opened': 'Ашылған күні',
    'portal.closed': 'Жабылған',
    'portal.in_progress': 'Жүргізілуде',
    'portal.stage': 'Кезең',
    'portal.no_stage': 'Кезең әлі белгіленбеген.',
    'portal.next_action': 'Келесі қадам',
    'portal.due': 'Мерзімі',
    'portal.progress': 'Іс барысы',
    'portal.open_case': 'Толығырақ',
    'portal.back_to_portal': 'Кабинетке оралу',
    'portal.case_not_found': 'Іс табылмады.',

    'portal.appointments': 'Кездесулер',
    'portal.no_appointments': 'Жоспарланған кездесу жоқ.',
    'portal.case_appointments': 'Осы іс бойынша кездесулер',

    'portal.case_documents': 'Құжаттар',
    'portal.no_documents': 'Сізге қолжетімді құжат әзірге жоқ.',
    'portal.document_download': 'Жүктеп алу',
    'portal.document_downloading': 'Жүктелуде…',
    'portal.document_unavailable': 'Құжат қолжетімсіз. Бетті жаңартып көріңіз.',
    'portal.signature_requests': 'Қол қоюға арналған сұраныстар',
    'portal.no_signature_requests': 'Қол қоюды күтіп тұрған құжат жоқ.',
    'portal.signature_expires': 'Мына күнге дейін жарамды:',
    'portal.signature_start': 'Қолмен қол қою',
    'portal.signature_read_first':
        'Қол қоймас бұрын жоғарыдағы құжаттарды оқып шығыңыз. Қолтаңбаңыз дәл сізге жіберілген нұсқаларға бекітіледі.',
    'portal.signature_pad_label': 'Қолтаңба өрісі',
    'portal.signature_pad_placeholder': 'Осы жерге тінтуірмен немесе саусақпен қол қойыңыз',
    'portal.signature_clear': 'Өшіру',
    'portal.signature_consent': 'Құжаттарды оқып шықтым және оларға қол қоямын.',
    'portal.signature_submit': 'Құжаттарға қол қою',
    'portal.signature_submitting': 'Қол қойылуда…',
    'portal.signature_cancel': 'Болдырмау',
    'portal.signature_ecp_start': 'ЭЦҚ-мен қол қою',
    'portal.signature_ecp_signing': 'ЭЦҚ-мен қол қойылуда…',
    'portal.signature_ecp_hint':
        'ЭЦҚ-мен қол қою үшін NCALayer іске қосылған компьютер қажет. Кілтті таңдап, құпиясөзді енгізу үшін NCALayer ашылады.',
    'portal.signature_ecp_required': 'Бұл құжаттарға ЭЦҚ-мен қол қою керек.',
    'portal.ncalayer_download': 'NCALayer жүктеп алу',
    'portal.signature_done': 'Қол қойылды.',
    'portal.appointment_status.requested': 'Өтінім қабылданды',
    'portal.appointment_status.confirmed': 'Расталды',
    'portal.appointment_status.completed': 'Өтті',
    'portal.appointment_status.cancelled': 'Өтпейді',
    'portal.appointment_no_time': 'Уақыт әлі келісілмеген',
    'portal.format.online': 'Онлайн',
    'portal.format.in_person': 'Кеңседе',
    'portal.duration_minutes': 'мин',

    'portal.messages': 'Сұрақтар',
    'portal.messages_hint':
        'Кездесуді ауыстыру немесе одан бас тарту қажет болса, осы жерге жазыңыз — кеңесші өзгерістер енгізеді.',
    'portal.message_placeholder': 'Сұрағыңызды жазыңыз',
    'portal.send': 'Жіберу',
    'portal.sending': 'Жіберілуде…',
    'portal.no_messages': 'Әзірге хат жоқ.',
    'portal.load_earlier': 'Бұрынғы хаттарды көрсету',
    'portal.you': 'Сіз',
    'portal.staff': 'Кеңесші',
    'portal.seen': 'Оқылды',
    'portal.message_required': 'Хат мәтінін жазыңыз.',

    'portal.book_appointment': 'Кездесуге жазылу',
    'portal.empty_title': 'Әзірге ашылған іс жоқ',
    'portal.no_appointments_hint': 'Кеңес алуға жазылған кезде, кездесу осында көрінеді.',
    'portal.no_documents_hint': 'Кеңесші құжат ашқан кезде ол осында пайда болады.',
    'portal.no_signature_requests_hint': 'Қол қою қажет болғанда, құжат осында пайда болады.',
    'portal.signature_awaiting': 'Қол қою қажет',
    'portal.step_done': 'Аяқталды',
    'portal.step_current': 'Ағымдағы кезең',
    'portal.step_upcoming': 'Алда',
    'portal.contact_title': 'Бізбен байланысу',
    'portal.contact_hint': 'Сұрағыңыз болса, қоңырау шалыңыз немесе жазыңыз — кеңесшіміз жауап береді.',
    'portal.stage_of': 'Кезең: {current} / {total}',
    'portal.nothing_needed': 'Қазір сізден ештеңе талап етілмейді',
    'portal.nothing_needed_hint': 'Сізден әрекет қажет болғанда, бұл осы жерде және хабарламаларда көрсетіледі.',
    'portal.signature_needed_title': 'Қолтаңбаңыз қажет',
    'portal.signature_needed_hint': 'Қол қоюды күтіп тұрған сұраныстар саны: {count}',
    'portal.signature_needed_action': 'Қол қоюға өту',
    'portal.case_closed_title': 'Іс жабылды',
    'portal.case_closed_hint': 'Сұрағыңыз болса, бізге жазыңыз немесе қоңырау шалыңыз.',
    'portal.next_stage': 'Келесі',
    'portal.next_appointment': 'Алдағы кездесу',
    'portal.earlier_appointments': 'Бұрын',
    'portal.cancel_appointment': 'Кездесуден бас тарту',
    'portal.cancel_appointment_reason': 'Бас тарту себебі',
    'portal.cancel_appointment_reason_placeholder': 'Мысалы: жоспарларым өзгерді',
    'portal.cancel_appointment_reason_required': 'Бас тарту себебін көрсетіңіз.',
    'portal.cancel_appointment_confirm': 'Бас тартуды растау',
    'portal.cancel_appointment_sending': 'Кездесу тоқтатылуда…',
    'portal.cancel_appointment_keep': 'Кездесуден бас тартпау',
    'portal.documents_failed': 'Құжаттарды жүктеу мүмкін болмады. Бетті жаңартып көріңіз.',
    'portal.signatures_failed_title': 'Қол қоюға арналған сұраныстарды тексеру мүмкін болмады',
    'portal.signatures_failed_hint': 'Бетті жаңартып көріңіз. Қате қайталанса, бізбен байланысыңыз.',
    'portal.pdf.download': 'PDF жүктеп алу',
    'portal.pdf.downloading': 'PDF дайындалуда…',
    'portal.pdf.failed': 'PDF дайындау мүмкін болмады. Кейінірек қайталап көріңіз.',
    'portal.pdf.title': 'Іс бойынша анықтама',
    'portal.pdf.generated_on': 'Дайындалған күні',
    'portal.pdf.provenance': '{case} ісі бойынша жеке кабинеттен алынған үзінді.',
    'portal.pdf.footer': 'Құжат ақпарат үшін берілді және банктің шешімі немесе ұсынысы болып табылмайды.',
    'portal.pdf.summary': 'Іс туралы',
    'portal.pdf.status': 'Күйі',
    'portal.pdf.column_service': 'Кездесу',
    'portal.pdf.column_when': 'Уақыты',
    'portal.pdf.column_document': 'Құжат',
    'portal.pdf.column_shared': 'Ашылған күні',
    'portal.pdf.consultation': 'Кеңес',
    'portal.pdf.closed_note': 'Бұл іс жабылған.',

    'portal.notifications': 'Хабарламалар',
    'portal.no_notifications': 'Жаңа хабарламалар жоқ.',
    'portal.mark_all_read': 'Барлығын оқылды деп белгілеу',
    'portal.mark_read': 'Оқылды деп белгілеу',
    'portal.unread': 'оқылмаған',
    'portal.push_hint': 'Браузер хабарландырулары',
    'portal.push_enable': 'Қосу',
    'portal.push_disable': 'Өшіру',
    'portal.push_blocked': 'Браузер хабарландыруларға тыйым салған.',

    'portal.notification.case_milestone': '{caseNumber} нөмірлі іс жаңа кезеңге өтті: {milestone}',
    'portal.notification.appointment_confirmed': 'Кездесу расталды: {date}, {time}',
    'portal.notification.appointment_confirmed_no_time': 'Кездесуіңіз расталды.',
    'portal.notification.appointment_cancelled': 'Кездесу өткізілмейді. Бізбен байланысыңыз.',
    'portal.notification.message_received': 'Кеңесшіден жауап келді: {preview}',
    'portal.notification.message_received_short': 'Кеңесшіден жауап келді.',
    'portal.notification.document_shared': 'Сізге жаңа құжат қолжетімді болды: {title}',
    'portal.notification.unknown': 'Жаңа хабарлама.',

    'portal.language': 'Хабарламалар тілі',
    'portal.language_hint': 'Шақырулар, еске салулар және хаттар осы тілде жазылады.',
    'portal.language_saved': 'Сақталды.',

    'portal.sections': 'Жеке кабинет бөлімдері',
    'portal.profile': 'Профиль',
    'portal.personal_details': 'Жеке деректер',
    'portal.full_name': 'Аты мен тегі',
    'portal.phone': 'Телефон',
    'portal.email': 'Электрондық пошта',
    'portal.not_given': 'Көрсетілмеген',
    'portal.iin': 'ЖСН',
    'portal.iin_hint':
        'ЖСН құжаттарға ЭЦҚ-мен қол қою үшін қажет. Ол бір рет енгізіледі және кейін өзгертілмейді.',
    'portal.iin_save': 'Сақтау',
    'portal.iin_confirm_title': 'ЖСН-ді тексеріңіз',
    'portal.iin_confirm_hint': 'Сақталғаннан кейін ЖСН-ді өзгерту мүмкін болмайды.',
    'portal.iin_confirm': 'Иә, сақтау',
    'portal.iin_edit': 'Түзету',
    'portal.iin_saving': 'Сақталуда…',
    'portal.iin_saved': 'ЖСН сақталды.',
    'portal.iin_recorded_hint': 'ЖСН өзгертілмейді. Қате болса, кеңесшіңізге хабарласыңыз.',

    'booking.title': 'Тегін консультацияға жазылу',
    'booking.progress': 'Жазылу қадамдары',
    'booking.closed': 'Онлайн жазылу қазір жабық. Бізге қоңырау шалыңыз — уақытты телефон арқылы келісеміз.',
    'booking.back': 'Артқа',
    'booking.next': 'Әрі қарай',
    'booking.submit': 'Өтінім жіберу',
    'booking.submitting': 'Жіберілуде…',
    'booking.free': 'Тегін',
    'booking.minutes': 'мин',
    'booking.loading_services': 'Қызметтер жүктелуде…',
    'booking.loading_slots': 'Бос уақыттар жүктелуде…',
    'booking.no_days': 'Жақын күндері бос уақыт жоқ. Бізге қоңырау шалыңыз.',
    'booking.first_name': 'Аты',
    'booking.last_name': 'Тегі',
    'booking.phone': 'Телефон',
    'booking.email': 'Электрондық пошта',
    'booking.too_many_submissions':
        'Тым көп өтінім жіберілді. Біраз күте тұрыңыз немесе бізге қоңырау шалыңыз.',

    'booking.consent':
        'Өтінімді жіберу арқылы аты-жөнім, телефон нөмірім және электрондық поштам консультацияға жазылу мақсатында өңделуіне келісім беремін.',
    'booking.consent_link': 'Құпиялылық саясаты',
    'booking.consent_required': 'Жалғастыру үшін деректерді өңдеуге келісім беруіңіз қажет.',
    'booking.specialist_unavailable':
        'Бұл маман қазір жазылым қабылдамайды. Басқасын таңдаңыз немесе таңдауды өткізіп жіберіңіз.',
    'booking.slot_taken': 'Бос емес',
    'booking.step.service': 'Қызмет',
    'booking.step.format': 'Кездесу форматы',
    'booking.step.city': 'Қала',
    'booking.step.specialist': 'Маман',
    'booking.step.day': 'Күні мен уақыты',
    'booking.step.time': 'Уақыты',

    'booking.format.online': 'Онлайн',
    'booking.format.in_person': 'Кеңседе',

    'booking.day.closed': 'Бұл күні жұмыс істемейміз',
    'booking.day.fully_booked': 'Бұл күнге бос уақыт қалмады',
    'booking.day.unavailable': 'Бұл күн қолжетімсіз',

    'booking.success.title': 'Өтінім қабылданды',
    'booking.success.slot_held':
        'Таңдаған уақытыңыз сізге ұсталып тұр. Растау үшін жақын арада хабарласамыз.',
    'booking.success.call_back': 'Жақын арада хабарласып, ыңғайлы уақытты келісеміз.',
    'booking.success.home': 'Басты бетке',

    'booking.nav.back': 'Басты бет',
    'booking.err.title': 'Қате',
    'booking.step.details': 'Деректер',
    'booking.s1.step': '1 / 4 · Қызмет',
    'booking.s1.title': 'Қызмет түрін таңдаңыз',
    'booking.s1.paid': 'Ақылы',
    'booking.s1.select': 'Қызметті таңдаңыз',
    'booking.s1.placeholder': '— Таңдаңыз —',
    'booking.s1.selected': '✓ Таңдалды',
    'booking.s1.offline_desc': 'Кеңседе тікелей кездесу. Күн мен уақытты таңдайсыз.',
    'booking.s1.online_desc': 'Видео немесе телефон арқылы. Кеңесші хабарласады.',
    'booking.s1.skip_notice': 'Онлайн кеңесте уақытты алдын ала таңдамайсыз — біз хабарласып келісеміз.',
    'booking.s1.free_in_person': 'Тегін кеңес тек кеңседе өткізіледі.',
    'booking.s2s.step': '2 / 4 · Маман',
    'booking.s2s.title': 'Маманды таңдаңыз',
    'booking.s2s.hint':
        'Менеджерді жұлдызды рейтингіне қарап таңдауға болады. ⭐\nЖұлдыздар менеджердің алдыңғы айдағы жұмыс нәтижелері мен көрсеткіштерін көрсетеді.',
    'booking.s2s.any': 'Маңызды емес',
    'booking.s2s.any_desc': 'Бос кеңесшіні өзіміз тағайындаймыз',
    'booking.s2s.loading': 'Мамандар жүктелуде…',
    'booking.s2s.none': 'Қазір таңдауға маман жоқ — өтінішіңізді кеңесшіге өзіміз береміз.',
    'booking.s2.step': '3 / 4 · Күн & Уақыт',
    'booking.s2.title': 'Ыңғайлы уақытты белгілеңіз',
    'booking.s2.pick_date': 'Алдымен күнді таңдаңыз',
    'booking.s2.none_for_specialist':
        'Бұл маманда осы қызмет бойынша бос уақыт жоқ. Артқа қайтып, басқа маманды таңдаңыз немесе таңдауды өткізіп жіберіңіз.',
    'booking.s2.prev_weeks': 'Алдыңғы апталар',
    'booking.s2.next_weeks': 'Келесі апталар',
    'booking.slots.morning': '☀️ Таң',
    'booking.slots.afternoon': '🌤️ Түс',
    'booking.slots.evening': '🌆 Кеш',
    'booking.s3.step': '4 / 4 · Деректер',
    'booking.s3.title': 'Байланыс ақпаратыңыз',
    'booking.s3.name_ph': 'Айгерім',
    'booking.s3.sname_ph': 'Бекова',
    'booking.s3.phone_ph': '700 000 00 00',
    'booking.s3.signed_in': 'Деректер жеке кабинетіңізден алынды.',
    'booking.s3.profile_loading': 'Деректеріңіз жүктелуде…',
    'booking.s3.other_person': 'Басқа адамды жазу үшін кабинеттен шығыңыз.',
    'booking.city.placeholder': '— Қаланы таңдаңыз —',
    'booking.side.why': 'Неге бізді таңдайды?',
    'booking.side.f1_title': 'Сенімді кеңес',
    'booking.side.f1_text': '5+ жылдық тәжірибе, 7000+ сәтті мәміле',
    'booking.side.f2_title': 'Жылдам нәтиже',
    'booking.side.f2_text': 'Алдын ала мақұлдауды 4–8 сағатта аласыз',
    'booking.side.f3_title': 'Жеке тәсіл',
    'booking.side.f3_text': 'Әр клиентке бөлек стратегия жасалады',
    'booking.side.contact_note': 'WhatsApp арқылы да жазуға болады',

    "error.consent_outdated": "Өтінімді жібермес бұрын бетті жаңартып, келісімнің өзекті мәтінін оқыңыз.",
    "error.portal_no_account": 'Белсенді профиліңіз жоқ. Кеңесшіңізге хабарласыңыз.',
    "error.case_not_found": "Іс табылмады. Бетті жаңартыңыз немесе кеңесшіге хабарласыңыз.",
    "error.document_not_found": "Құжат қолжетімсіз. Бетті жаңартыңыз немесе кеңесшіге хабарласыңыз.",
    "error.signature_not_found": 'Қол қою сұранысы табылмады. Бетті жаңартыңыз.',
    "error.signature_too_many_strokes": "Қолтаңбада сызықтар тым көп. Өрісті тазалап, қайта қол қойыңыз.",
    "error.signature_off_pad": "Қолтаңба өрістің шегінен шығып кеткен. Өрісті тазалап, қайта қол қойыңыз.",
    "error.session_ended": "Сеанс аяқталды. Қайта кіріңіз.",
    "error.session_superseded": 'Сеанс аяқталды: тіркелгіңізге басқа құрылғыдан кірілді. Қайта кіріңіз.',
    "error.forbidden": "Бұл әрекетті орындауға рұқсатыңыз жоқ.",
    "error.not_found": "Сұралған деректер табылмады. Бетті жаңартыңыз.",
    "error.conflict": "Деректер өзгерді. Бетті жаңартып, қайталап көріңіз.",
    "error.booking_date_unavailable": "Бұл күнге жазылу мүмкін емес. Басқа күнді таңдаңыз.",
    "validation.invalid": 'Осы өрістегі мәнді тексеріңіз.',
    "validation.out_of_range": "Мән рұқсат етілген ауқымнан тыс.",
    "validation.password_symbol": "Құпиясөзге кемінде бір арнайы таңба қосыңыз.",
    "validation.password_digit": "Құпиясөзге кемінде бір сан қосыңыз.",
    "validation.password_lowercase": "Құпиясөзге кемінде бір кіші латын әрпін қосыңыз.",
    "validation.password_uppercase": "Құпиясөзге кемінде бір бас латын әрпін қосыңыз.",
    "validation.password_unique": "Құпиясөзде көбірек түрлі таңба қолданыңыз.",
    'error.generic': 'Күтпеген қате. Кейінірек қайталап көріңіз.',
    'error.network': 'Сервермен байланыс жоқ. Интернетке қосылымды тексеріңіз.',
    'error.invalid_credentials': 'Кіру деректері қате.',
    'error.locked_out': 'Тіркелгіңіз уақытша бұғатталған. Кейінірек қайталап көріңіз.',
    'error.invalid_invitation': 'Сілтеме жарамсыз немесе мерзімі өткен. Кеңесшіңізден жаңасын сұраңыз.',
    'error.too_many_requests': 'Тым көп рет әрекет жасалды. Сәл күтіп, қайталап көріңіз.',
    'error.phone_already_in_use': 'Бұл нөмір бұрыннан тіркелген. Осы нөмірмен кіріп көріңіз.',
    'error.iin_already_in_use': 'Бұл ЖСН бұрыннан тіркелген. Осы ЖСН-мен кіріп көріңіз.',
    'error.portal_iin_fixed': 'ЖСН бұрыннан сақталған. Қате болса, кеңесшіңізге хабарласыңыз.',
    'error.portal_iin_in_use': 'Бұл ЖСН басқа тіркелгіде көрсетілген. Кеңесшіңізге хабарласыңыз.',
    'error.email_already_in_use': 'Бұл электрондық пошта мекенжайы бұрыннан тіркелген. Осы мекенжаймен кіріп көріңіз.',
    'error.slot_taken': 'Бұл уақытты жаңа ғана алып қойды. Басқа уақытты таңдаңыз.',
    'error.slot_not_offered': 'Бұл уақыт ұсынылмайды. Көрсетілген уақыттардың бірін таңдаңыз.',
    'error.booking_closed': 'Онлайн жазылу қазір жабық. Бізге қоңырау шалыңыз.',
    'error.service_unavailable': 'Бұл қызмет енді ұсынылмайды. Басқасын таңдаңыз.',
    'error.signature_expired': 'Сұраныстың мерзімі өтті. Кеңесшіден жаңасын жіберуді сұраңыз.',
    'error.signature_closed': 'Бұл сұраныс бойынша енді қол қою қажет емес. Бетті жаңартыңыз.',
    'error.signature_already_signed': 'Сіз бұл құжаттарға қол қойып қойғансыз.',
    'error.signature_package_changed':
        'Құжаттар сізге жіберілгеннен кейін өзгертілген, сондықтан оларға қол қою мүмкін емес. Кеңесшіге хабарласыңыз.',
    'error.signature_not_drawn': 'Қол қоймас бұрын қолтаңбаңызды өріске қойыңыз.',
    'error.signature_ecp_required': 'Бұл құжаттарға ЭЦҚ-мен қол қою керек.',
    'error.signature_manual_required': 'Бұл құжаттарға қолмен қол қою керек.',
    'error.ecp_service_unavailable': 'Қолтаңбаны тексеру қызметі қазір жауап бермейді. Сәлден соң қайталаңыз.',
    'error.ecp_invalid': 'Қолтаңба тексеруден өтпеді. Қайталап көріңіз.',
    'error.ecp_wrong_certificate': 'Кіруге арналған кілтті (AUTH) емес, қол қоюға арналған кілтті таңдаңыз.',
    'error.ecp_certificate_expired': 'Сертификаттың мерзімі өткен. Жаңа ЭЦҚ кілтін алыңыз.',
    'error.ecp_certificate_revoked': 'Бұл сертификаттың күші жойылған. Жаңа ЭЦҚ кілтін алыңыз.',
    'error.ecp_iin_mismatch': 'Бұл ЭЦҚ кілті басқа ЖСН иесіне берілген. Өз кілтіңізбен қол қойыңыз.',
    'error.ncalayer_unavailable': 'NCALayer-ге қосылу мүмкін болмады. Компьютерде оны іске қосып, қайталап көріңіз.',
    'error.ncalayer_timeout': 'NCALayer уақытында жауап бермеді. Қайталап көріңіз.',
    'error.ncalayer_failed': 'Қол қою орындалмады. Таңдалған кілт пен құпиясөзді тексеріңіз.',

    'validation.required': 'Бұл өрісті толтырыңыз',
    'validation.phone': 'Нөмірді +7 700 000 00 00 пішімінде енгізіңіз',
    'validation.email': 'Дұрыс электрондық пошта мекенжайын енгізіңіз',
    'validation.too_short': 'Мән тым қысқа',
    'validation.too_long': 'Мән тым ұзын',
    'validation.format': 'Пішімі дұрыс емес',

    'nav.blog': 'Посттар',

    'blog.title': 'Посттар',
    'blog.subtitle': 'Ипотека туралы түсінікті тілмен жазылған мақалалар.',
    'blog.empty': 'Әзірге мақалалар жоқ.',
    'blog.read_more': 'Толығырақ',
    'blog.previous': 'Алдыңғы',
    'blog.next': 'Келесі',

    'article.back_to_blog': 'Посттарға оралу',
    'article.gone.title': 'Мақала алынып тасталды',
    'article.gone.body': 'Бұл мақала бұрын жарияланған еді, қазір қолжетімсіз.',
    'article.missing.title': 'Мақала табылмады',
    'article.missing.body': 'Мұндай мекенжайдағы мақала жоқ. Сілтемені тексеріңіз.',
    'article.cta.title': 'Сұрағыңыз бар ма?',
    'article.cta.body': 'Кеңесшімен тегін кездесуге жазылыңыз.',
    'article.cta.action': 'Кеңеске жазылу',

    'share.title': 'Бөлісу',
    'share.copy': 'Сілтемені көшіру',
    'share.copied': 'Сілтеме көшірілді',
    'share.native': 'Басқа қолданба',

    'not_found.title': 'Бет табылмады',
    'not_found.body': 'Бұл бет жойылған немесе оның мекенжайы өзгерген болуы мүмкін.',
    'not_found.home': 'Басты бетке оралу',

    'common.optional': 'міндетті емес',
    'common.loading': 'Жүктелуде…',

    // ── The public marketing pages ────────────────────────────────────────────
    //
    // Ported from the live static site, where the *markup* is the Kazakh version and
    // `window.I18N_RU` is the Russian dictionary. Both were read the way `i18n.js` reads
    // them rather than transcribed, so the port is faithful — and moving them here turns the
    // live engine's silent fall back to Kazakh into a compile error, which is a reason for
    // the port rather than a side effect of it.
    'site.page.title': 'Ипотекалық дәрігер — Сіздің сенімді ипотекалық сарапшыларыңыз',
    'site.page.desc': 'Ипотекалық дәрігер — сіздің сенімді ипотекалық сарапшыларыңыз. Біз үй сатып алу жолын жеңілдетеміз.',
    'site.nav.home': 'Басты бет',
    'site.nav.about': 'Біз туралы',
    'site.nav.programs': 'Бағдарламалар',
    'site.nav.faq': 'Сұрақтар',
    'site.nav.contact': 'Байланыс',
    'site.nav.cta': 'Кеңес алу',
    'site.hero.title': 'Сенімді ипотекалық сарапшыларыңыз',
    'site.hero.desc': 'Біз үй сатып алу жолын жекелендірілген ипотекалық шешімдермен, тиімді мөлшерлемелермен және сарапшылық көмекпен жеңілдетеміз — алғашқы өтініштен мәмілені аяқтағанға дейін.',
    'site.hero.cta': 'Тегін кеңес алу',
    'site.hero.posts': 'Посттарды оқу',
    'site.hero.stat1': 'Жылдық тәжірибе',
    'site.hero.stat2': 'Жабылған ипотека',
    'site.hero.stat3': 'Клиенттер ризашылығы',
    'site.about.label': 'Біз кімбіз',
    'site.about.title': '2021 жылдан бері үй иесі болуға\nжол салып келеміз',
    'site.about.subtitle': '«Ипотекалық дәрігер» әрбір отбасы өз үйіне ашық әрі қиындықсыз ие болуға лайықты деген сеніммен құрылған. Біз нарықты терең білуіміз бен клиенттерге деген шынайы қамқорлығымызды ұштастырамыз.',
    'site.about.cta': 'Жолыңызды бастаңыз',
    'site.ben1.title': 'Толық реттелетін',
    'site.ben1.desc': 'FCA рұқсаты бар және реттеледі. Сіздің мүдделеріңіз әрқашан қорғалған.',
    'site.ben2.title': 'Ең жақсы мөлшерлемелер',
    'site.ben2.desc': 'Көпшілікке қолжетімді емес эксклюзивті мөлшерлемелерге қол жеткізіңіз.',
    'site.ben3.title': '24/7 Қолдау',
    'site.ben3.desc': 'Біздің команда кез келген уақытта көмектесуге дайын.',
    'site.ben4.title': 'Жылдам мақұлдау',
    'site.ben4.desc': 'Шешімдер көбінесе бірнеше күн емес, бірнеше сағат ішінде қабылданады.',
    'site.ben5.title': 'Сарапшылар командасы',
    'site.ben5.desc': 'Ондаған жылдық тәжірибесі бар білікті кеңесшілер.',
    'site.ben6.title': 'Нәтижелер тарихы',
    'site.ben6.desc': '7,000-нан астам сәтті ипотека және 98% риза клиенттер.',
    'site.spec.label': 'Біздің команда',
    'site.spec.title': 'Біздің мамандар',
    'site.spec.subtitle': 'Ипотека жолында сізге көмектесетін тәжірибелі кеңесшілер командасы.',
    'site.spec.btn': 'Кеңес алу',
    'site.spec.details': 'Толығырақ',
    'site.spec.close': 'Жабу',
    'site.spec.unrated': 'Әзірге рейтинг жоқ',
    'site.spec.book': 'Кеңеске жазылу',
    'site.spec.rating': 'Рейтинг: 5-тен {stars}',
    'site.city.astana': 'Астана',
    'site.city.almaty': 'Алматы',
    'site.prog.label': 'Ипотека',
    'site.prog.title': 'Ипотекалық бағдарламалар',
    'site.prog.subtitle': 'Біздің әр түрлі ипотекалық бағдарламаларымыз барлық клиенттерге қолжетімді.',
    'site.prog.zoom_hint': 'Үлкейту үшін екі рет түртіңіз',
    'site.faq.label': 'Жиі қойылатын сұрақтар',
    'site.faq.title': 'Ипотекалық несие туралы жиі қойылатын сұрақтарға жауап!',
    'site.faq.q1': 'Ипотека алу үшін қандай құжаттар қажет?',
    'site.faq.a1': '1) жеке басты куәландыратын құжат (жеке куәлік немесе ҚР паспорты) электрондық нұсқасы да жарамды. (түп нұсқасы)\n2) Некеде болсаңыз Ерлі-зайыптылардың Неке туралы куәлігі. (түп нұсқасы)\n3) Мемлекеттік бағдарламалар бойынша 18ге толмаған баллардың туу туралы куәліктері (түп нұсқасы)\nКейбір бағдарламалар бойынша қосымша құжаттар қажет болуы мүмкін - сарапшымыз жауап береді',
    'site.faq.q2': 'Алдын ала мақұлдау қанша уақыт алады?',
    'site.faq.a2': 'Біздің клиенттеріміз алдын ала мақұлдауды орта есеппен 24 сағат ішінде алады. Ал кейбір жағдайларда тіпті бірнеше сағат ішінде шешім шығуы мүмкін. Барлық қажетті құжаттар дайын болса, процесс айтарлықтай жеделдейді.',
    'site.faq.q3': 'Сіздің қызметтеріңіз тегін бе?',
    'site.faq.a3': 'Ипотекалық бағдарламалар бойынша кеңес алу және тиімді бағдарлама таңдау тегін.',
    'site.faq.q4': 'Несиелік тарихым нашар болса, ипотека ала аламын ба?',
    'site.faq.a4': 'Иә, мүмкін. Біз нашар несиелік тарихы бар клиенттермен жұмыс жасаймыз. Арнайы бағдарламалар мен балама қаржыландыру жолдары арқылы шешім табуға тырысамыз. Консультацияда жеке жағдайыңызды талдаймыз.',
    'site.faq.q5': 'Мемлекеттік бағдарлама аясында пәтер алуға көмек бере аласыздарма?',
    'site.faq.a5': 'Әрине. Жаңа концепция (2-10-20 / 5-10-20), 7-20-25, Наурыз бағдарламасы сияқты Мемлекеттік бағдарлама бойынша толық кеңес бере аламыз. Сіздің жағдайыңызға қай бағдарлама қолайлы екенін анықтап, Ипотека рәсімдеуге көмектесеміз.',
    'site.faq.q6': 'Қайта қаржыландыру деген не? Ол маған тиімді ма?',
    'site.faq.a6': 'Қайта қаржыландыру тиімділігі жеке жағдайыңызға байланысты. Егер сіздің рәсімдеген Ипотекалық несиеңіздің пайыздық мөлшерлемесі қазіргі нарықтық ипотекалық бағдарламалардың пайыздық мөлшерлемесінен әжептеуір жоғары болса онда сізге қайта қаржыландыру тиімді болады. Толық ақпарат алу үшін Біздің офисқа тегін кеңес алуға келіңіздер.',
    'site.faq.more_text': 'Сұрағыңызға жауап таппадыңыз ба?',
    'site.faq.more_action': 'Посттарды оқу',

    'site.soc.label': 'Әлеуметтік желілер',
    'site.soc.title': 'Бізді желіде табыңыз',
    'site.soc.subtitle': 'Ипотека жаңалықтары, кеңестер және сарапшы пікірлері — барлық платформада бізбен бірге болыңыз.',
    'site.soc.youtube': 'YouTube-тегі тегін видео сабақтар: Баспана алудың тиімді жолдары. Банк тілін қолданбай, қарапайым түсіндіру',
    'site.soc.instagram': 'Қарапайым қазақ тілінде ақпараттар. 100% сенімді жаңалықтар. Біздің жұмысымыздың нәтижелері.',
    'site.soc.tiktok': 'ТикТок каналымыз — үнемі жаңа және өзекті ақпараттар',
    'site.soc.whatsapp': 'Тікелей байланыс\n& кеңес алу',
    'site.partners.label': 'Серіктестер',
    'site.partners.title': 'Сенімді серіктестеріміз',
    'site.partners.intro': 'Қазақстанның жетекші банктері мен қаржы институттарымен тығыз ынтымақтастықта жұмыс жасаймыз. Бұл бізге клиенттерімізге ең тиімді шарттарды ұсынуға мүмкіндік береді.',
    'site.contact.label': 'Байланыс',
    'site.contact.title': 'Біз әр қадамыңызда\nкөмектесуге дайынбыз',
    'site.contact.desc': 'Алғашқы үйіңізді сатып алсаңыз да, қайта қаржыландыру жасағыңыз келсе де — біздің команда көмекке дайын. Қысымсыз, тек кәсіби кеңес.',
    'site.contact.phone': 'Телефон',
    'site.contact.office': 'Офис',
    'site.contact.office_almaty': '🌍 Алматы, Әуезов ауданы, Жетісу-1, 40-үй 🏢 "Елдаулет" сауда орталығы 🔹 2-қабат, 7-кеңсе',
    'site.contact.office_astana': '🌍 Астана, Қажымұқан 12А🔹 Жеке кіру, 1-қабат 🔹 Кіреберіс – Сәтбаев көшесі жағынан',
    'site.contact.open_2gis': '2GIS картасында ашу',
    'site.contact.hours': 'Жұмыс уақыты',
    'site.contact.hours_val': 'Демалыссыз 10:00 – 19:00',
    'site.contact.schedule': 'Жұмыс кестесі',
    // The opening hours and the word "free" are bold on the live page, so they are their own
    // keys rather than HTML inside one: the sentence around them is not the same shape in both
    // languages, and Kazakh puts a word after the hours where Russian puts nothing.
    'site.contact.schedule_sub1_line1': 'Біз демалыссыз күн сайын жұмыс істейміз!',
    'site.contact.schedule_sub1_prefix': 'Уақыты: ',
    'site.contact.schedule_sub1_hours': '10:00–19:00',
    'site.contact.schedule_sub1_suffix': ' аралығы',
    'site.contact.schedule_sub2_prefix': 'Алдын ала жазылусыз – тірі кезек арқылы қабылдаймыз. Кеңес беру – ',
    'site.contact.schedule_sub2_free': 'ТЕГІН!',
    'site.contact.map_almaty': 'Жетісу-1, 40-шы үй. 7ші офис',
    'site.contact.map_astana': 'Қажымұқан, 12а',
    'site.footer.desc': '2021 жылдан бергі сенімді ипотекалық сарапшылар. Біз үй иесі болуды қолжетімді және қиындықсыз етеміз.',
    'site.footer.nav': 'Навигация',
    'site.footer.faq': 'Жиі қойылатын сұрақтар',
    'site.footer.socials': 'Желілер',
    'site.footer.partners': 'Серіктестер',
    'site.footer.services': 'Қызметтер',
    'site.footer.svc1': 'Алғаш рет үй алу',
    'site.footer.svc2': 'Қайта қаржыландыру',
    'site.footer.svc3': 'Инвестициялық ипотека',
    'site.footer.svc4': 'Коммерциялық ипотека',
    'site.footer.svc5': 'Мемлекеттік бағдарламалар',
    'site.footer.tagline': 'Сіздің үйіңіз — біздің басты мақсатымыз.',
    'site.about.check1.title': 'Нарықты толық қамту',
    'site.about.check1.text': 'Біз сізге ең тиімді пайыздық мөлшерлемемен баспана алу үшін жүздеген несие берушілерді салыстырамыз! (бағдарламалардың артықшылықтары мен кемшіліктерін айтамыз)',
    'site.about.check2.title': 'Жасырын комиссиялар жоқ',
    'site.about.check2.text': 'Алғашқы қоңыраудан бастап толық ашықтық. Келісімшартқа қол қоймас бұрын әрбір санды түсіндіреміз.',
    'site.about.check3.title': 'Жеке кеңесші',
    'site.about.check3.text': 'Сіздің жағдайыңызды білетін және кез келген уақытта көмекке дайын бір маманмен жұмыс істейсіз.',
    'site.footer.copy': '© {year} Ипотекалық дәрігер. Барлық құқықтар қорғалған.',
    'site.footer.policy': 'Құпиялылық саясаты',
    'site.footer.terms': 'Пайдалану шарттары',
    'site.specialists.city': 'Қала',
    'site.programs.slide': 'Бағдарлама',
    'site.programs.previous': 'Алдыңғы бағдарлама',
    'site.programs.next': 'Келесі бағдарлама',

    // Labels for the controls the ported page carries: the burger, the language pair, and the
    // three carousels' arrows and dots. They are read aloud and never seen.
    'site.nav.menu': 'Мәзір',
    'site.nav.language': 'Тіл / Язык',
    'site.hero.slides': 'Слайдтар',
    'site.hero.slide': 'Слайд',
    'site.hero.slide1_alt': 'Ипотекалық кеңесшілер — сенімді команда',
    'site.hero.slide2_alt': 'Ипотекалық кеңесшілер — кездесу',
    'site.spec.previous': 'Алдыңғы',
    'site.spec.next': 'Келесі',
    'site.prog.alt': 'Ипотекалық бағдарлама',
    'site.prog.zoom': 'Үлкейту',
    'site.prog.close': 'Жабу',
    'site.prog.image': 'Бағдарлама суреті',

    // ── The privacy policy and terms page ─────────────────────────────────────
    //
    // One page with two tabbed documents, ported the same way and from the same source of
    // truth: `pp.*` is the privacy policy, `tt.*` the terms of use.
    'cookies.title': 'Біз cookie файлдарын пайдаланамыз',
    'cookies.body':
        'Сайттың жұмысы үшін қажетті файлдар әрқашан қолданылады. Статистика жинайтын аналитикалық файлдарды тек сіздің келісіміңізбен қосамыз.',
    'cookies.policy_link': 'Толығырақ — Құпиялылық саясатында',
    'cookies.accept': 'Келісемін',
    'cookies.decline': 'Тек қажеттілері',
    'cookies.prefs.title': 'Аналитикалық cookie файлдарына келісіміңіз',
    'cookies.prefs.state_granted':
        'Қазір: аналитика қосулы. Келісімді кез келген уақытта кері қайтара аласыз.',
    'cookies.prefs.state_denied': 'Қазір: аналитика өшірулі. Тек сайтқа қажетті файлдар қолданылады.',
    'cookies.prefs.state_undecided': 'Сіз әлі таңдау жасаған жоқсыз. Аналитика өшірулі.',
    'cookies.prefs.withdraw': 'Келісімді қайтарып алу',
    'cookies.prefs.ask_again': 'Қайта сұрау',

    'policy.page.title': 'Құпиялылық саясаты & Пайдалану шарттары — Ипотекалық дәрігер',
    'policy.page.desc': 'Ипотекалық дәрігер — Құпиялылық саясаты және Пайдалану шарттары.',
    'policy.nav.back': 'Басты бетке',
    'policy.hero.badge': 'Соңғы жаңарту: 2026 жылғы 1 қаңтар',
    'policy.hero.sub': 'Біздің деректеріңізді қалай пайдаланатынымыз және сайттан пайдалану шарттарымыз туралы толық ақпарат',
    'policy.tab.privacy': 'Құпиялылық саясаты',
    'policy.tab.terms': 'Пайдалану шарттары',
    'policy.hero.title_before': 'Заңдық',
    'policy.hero.title_emphasis': 'ақпарат',
    'policy.hero.title_after': 'беті',
    'policy.contact.email': 'Email',
    'policy.contact.phone': 'Телефон',
    'policy.side.contents': 'Мазмұны',
    'policy.side.cta_title': 'Сұрақтарыңыз бар ма?',
    'policy.side.cta_sub': 'Кеңесші тегін жауап береді — жазыңыз немесе қоңырау шалыңыз.',
    'policy.side.whatsapp': 'WhatsApp-та жазу',
    'policy.misc.updated': 'Жаңартылған: 1 қаңтар 2026',
    'policy.pp.intro.label': 'Кіріспе',
    'policy.pp.intro.h2': 'Деректер құпиялылығы саясаты',
    'policy.pp.intro.p1': '«Ипотекалық дәрігер» компаниясы (бұдан әрі — «Біз», «Компания») клиенттеріміздің жеке деректерін қорғауды өзінің негізгі міндеттемесі деп санайды. Осы Құпиялылық саясаты сіздің ipotekalyk-dariger.kz веб-сайтымызды (бұдан әрі — «Сайт») пайдалану барысында Компанияның жеке деректерді жинау, пайдалану, сақтау және қорғау тәртібін реттейді.',
    'policy.pp.intro.box': 'Сайтты пайдалану арқылы сіз осы Саясатта баяндалған шарттарға сәйкес деректеріңізді өңдеуге келісетіндігіңізді растайсыз.',
    'policy.pp.collect.label': 'Деректер жинау',
    'policy.pp.collect.h2': 'Қандай деректер жиналады',
    'policy.pp.collect.p1': 'Сізге сапалы қызмет көрсету мақсатында Біз келесі деректерді жинай аламыз:',
    'policy.pp.collect.h3a': 'Тікелей берілетін деректер',
    'policy.pp.collect.a1': 'Аты-жөні, телефон нөмірі және электрондық пошта мекенжайы — байланыс формасы арқылы жіберілген кезде',
    'policy.pp.collect.a2': 'Ипотекаға байланысты мәліметтер: табыс деңгейі, несие тарихы (егер өз еркімен хабарласа)',
    'policy.pp.collect.a3': 'Хат-хабарлар мен сұрақтардың мазмұны',
    'policy.pp.collect.h3b': 'Автоматты түрде жиналатын деректер',
    'policy.pp.collect.b1': 'IP-мекенжай және браузер түрі',
    'policy.pp.collect.b2': 'Сайтты пайдалану статистикасы (қараған беттер, сеанс ұзақтығы)',
    'policy.pp.collect.b3': 'Сайтқа кіру уақыты мен күні',
    'policy.pp.collect.b4': 'Cookie файлдары арқылы алынатын деректер',
    'policy.pp.use.label': 'Пайдалану мақсаты',
    'policy.pp.use.h2': 'Деректерді пайдалану мақсаттары',
    'policy.pp.use.p1': 'Жиналған деректер тек заңды мақсаттарда ғана қолданылады:',
    'policy.pp.use.l1': 'Ипотекалық кеңес беру және сұрауларға жауап қайтару',
    'policy.pp.use.l2': 'Клиенттік шарт жасасу және орындау',
    'policy.pp.use.l3': 'Сайт жұмысын жақсарту және мазмұнды жекелендіру',
    'policy.pp.use.l4': 'Заң талаптарын орындау (мысалы, салықтық есептілік)',
    'policy.pp.use.l5': 'Алаяқтық пен қауіпсіздік тәуекелдерін анықтау',
    'policy.pp.use.box': 'Біз сіздің жеке деректеріңізді маркетинг мақсатында үшінші тараптарға ешқашан сатпаймыз немесе жарнамалық мақсатта жіберіп береміз.',
    'policy.pp.share.label': 'Деректерді бөлісу',
    'policy.pp.share.h2': 'Үшінші тараптармен бөлісу',
    'policy.pp.share.p1': 'Деректеріңіз тек мынадай жағдайларда серіктес банктер мен ұйымдарға жіберілуі мүмкін:',
    'policy.pp.share.l1': 'Ипотекалық өтінімді өңдеу үшін сіздің айқын келісіміңізбен',
    'policy.pp.share.l2': 'Заң немесе сот шешімі талап еткен жағдайда',
    'policy.pp.share.l3': 'Компанияны сату немесе қайта құрылымдау кезінде (сіз алдын ала хабарланасыз)',
    'policy.pp.share.p2': 'Барлық серіктес ұйымдар деректерді қорғаудың жеткілікті деңгейін қамтамасыз ету шартымен ғана жұмыс жасайды.',
    'policy.pp.cookies.label': 'Cookie',
    'policy.pp.cookies.h2': 'Cookie файлдары',
    'policy.pp.cookies.p1': 'Сайт сіздің тәжірибеңізді жақсарту үшін cookie файлдарын пайдаланады. Браузер параметрлерінен cookie файлдарын кез келген уақытта өшіруге болады. Алайда, бұл сайттың кейбір функцияларын шектеуі мүмкін.',
    'policy.pp.cookies.l1': 'Міндетті cookie: Сайт жұмысы үшін қажет — пайдаланушы сеансын сақтайды',
    'policy.pp.cookies.l2': 'Аналитикалық cookie: Сайтты пайдалану статистикасын жинайды (Google Analytics)',
    'policy.pp.cookies.l3': 'Функционалдық cookie: Тілдік параметрлерді есте сақтайды',
    'policy.pp.rights.label': 'Сіздің құқықтарыңыз',
    'policy.pp.rights.h2': 'Жеке деректерге қатысты құқықтарыңыз',
    'policy.pp.rights.p1': 'ҚР «Жеке деректер және оларды қорғау туралы» Заңына сәйкес сізде мынадай құқықтар бар:',
    'policy.pp.rights.l1': 'Өзіңіз туралы сақталатын деректерге қол жеткізу',
    'policy.pp.rights.l2': 'Дұрыс емес деректерді түзету талабы',
    'policy.pp.rights.l3': 'Деректерді жою («ұмытылу құқығы»)',
    'policy.pp.rights.l4': 'Деректерді өңдеуге берілген келісімді кері қайтарып алу',
    'policy.pp.rights.l5': 'Деректер порталдылығы — деректеріңізді алып, басқа ұйымға беруге болады',
    'policy.pp.rights.p2': 'Өтінімдер 30 күн ішінде қаралады. Сұранысты ipotekalyk_dariger1@mail.ru мекенжайына жіберіңіз.',
    'policy.pp.security.label': 'Қауіпсіздік',
    'policy.pp.security.h2': 'Деректер қауіпсіздігі',
    'policy.pp.security.p1': 'Компания клиенттер деректерін қорғау үшін техникалық және ұйымдық шаралар қолданады:',
    'policy.pp.security.l1': 'SSL/TLS шифрлау арқылы деректер берілісін қорғау',
    'policy.pp.security.l2': 'Деректерге қол жетімділікті шектеу (тек уәкілетті қызметкерлер)',
    'policy.pp.security.l3': 'Жүйелерді кибер қауіптерден қорғайтын антивирустық бағдарламалар',
    'policy.pp.security.l4': 'Деректерді сақтаудың мерзімі — қызмет аяқталғаннан кейін 5 жыл',
    'policy.pp.contact.label': 'Байланыс',
    'policy.pp.contact.h2': 'Сұрақтарыңыз бен шағымдарыңыз',
    'policy.pp.contact.p1': 'Осы Саясатқа қатысты кез келген сұрақ немесе алаңдаушылық болса, бізбен хабарласыңыз:',
    'policy.pp.contact.h4': 'Деректерді қорғау жөніндегі байланыс',
    'policy.tt.intro.label': 'Жалпы ережелер',
    'policy.tt.intro.h2': 'Пайдалану шарттары',
    'policy.tt.intro.p1': 'Осы Пайдалану шарттары «Ипотекалық дәрігер» сайтын пайдалану кезінде пайдаланушы мен Компания арасындағы заңдық қатынасты реттейді. Сайтты пайдалану арқылы сіз осы шарттарды толық қабылдайсыз.',
    'policy.tt.intro.box': 'Сайттың мазмұны ақпараттық сипатта ғана берілген. Ипотека рәсімдеу — жеке кеңес сессиясы арқылы жүргізіледі. Сайтта берілген мөлшерлемелер нақты ұсыныс болып табылмайды.',
    'policy.tt.elig.label': 'Пайдаланушылар',
    'policy.tt.elig.h2': 'Пайдалану шарттары',
    'policy.tt.elig.p1': 'Сайтты пайдалану үшін мынадай шарттар орындалуы тиіс:',
    'policy.tt.elig.l1': '18 жас және одан үлкен болу',
    'policy.tt.elig.l2': 'Қазақстан Республикасының заңнамасын сақтау',
    'policy.tt.elig.l3': 'Жалған ақпарат беруден немесе алдауша іс-әрекеттерден аулақ болу',
    'policy.tt.elig.l4': 'Сайтты тек заңды мақсатта пайдалану',
    'policy.tt.ip.label': 'Зияткерлік меншік',
    'policy.tt.ip.h2': 'Авторлық құқық пен зияткерлік меншік',
    'policy.tt.ip.p1': 'Сайттың барлық мазмұны — мәтіндер, логотиптер, бейнелер, дизайн элементтері, бағдарламалық код — «Ипотекалық дәрігер» компаниясының меншігі болып табылады және авторлық құқықпен қорғалады.',
    'policy.tt.ip.l1': 'Жазбаша рұқсатсыз кез келген мазмұнды көшіруге, тарқатуға немесе коммерциялық мақсатта пайдалануға тыйым салынады',
    'policy.tt.ip.l2': 'Жеке, коммерциялық емес мақсатта мазмұнды оқуға және сілтемелер жасауға рұқсат берілген',
    'policy.tt.ip.l3': 'Бұзушылық анықталған жағдайда заңдық шара қолданылады',
    'policy.tt.prohib.label': 'Тыйым салынған',
    'policy.tt.prohib.h2': 'Тыйым салынған іс-әрекеттер',
    'policy.tt.prohib.p1': 'Сайтты пайдалану кезінде мыналарға тыйым салынады:',
    'policy.tt.prohib.l1': 'Зиянды бағдарламалар, вирустар немесе деструктивті код жіберу',
    'policy.tt.prohib.l2': 'Автоматты боттар арқылы деректерді жинау (web scraping)',
    'policy.tt.prohib.l3': 'Сайттың жұмысына кедергі жасау немесе бұзу әрекеттері',
    'policy.tt.prohib.l4': 'Басқа пайдаланушының немесе компанияның атын алдауша пайдалану',
    'policy.tt.prohib.l5': 'Заңсыз мақсаттарда немесе ҚР заңнамасын бұза отырып пайдалану',
    'policy.tt.prohib.box': 'Шарттарды бұзу жағдайында Компания сайтқа қолжетімділікті шектеу және заңдық шаралар қолдану құқығын өзіне қалдырады.',
    'policy.tt.disc.label': 'Жауапкершілік шегі',
    'policy.tt.disc.h2': 'Жауапкершіліктен бас тарту',
    'policy.tt.disc.p1': '«Ипотекалық дәрігер» сайтты «бар күйінде» ұсынады. Компания мынадай жағдайлар үшін жауапты болмайды:',
    'policy.tt.disc.l1': 'Сайт мазмұны негізінде жасалған қаржылық шешімдердің салдары',
    'policy.tt.disc.l2': 'Сайттың уақытша жетімсіздігі немесе техникалық ақаулар',
    'policy.tt.disc.l3': 'Үшінші тарап сайттарының мазмұны (сілтемелер арқылы өтілген)',
    'policy.tt.disc.l4': 'Бақылауымыздан тыс жағдайлардан туындаған залал (форс-мажор)',
    'policy.tt.disc.p2': 'Сайттағы ипотека мөлшерлемелері мен шарттар ақпараттық сипатта берілген және банктің ресми ұсынысы болып табылмайды. Нақты шарттар жеке кеңесте анықталады.',
    'policy.tt.links.label': 'Сыртқы сілтемелер',
    'policy.tt.links.h2': 'Үшінші тарап сайттарына сілтемелер',
    'policy.tt.links.p1': 'Сайтымызда серіктес банктер мен ұйымдарға сілтемелер болуы мүмкін. Бұл сілтемелер тек ыңғайлылық үшін берілген. «Ипотекалық дәрігер» сол сайттардың мазмұны мен саясаты үшін жауапты болмайды. Сіз сол сайттарды пайдаланар алдында олардың жеке шарттарымен танысуды ұсынамыз.',
    'policy.tt.changes.label': 'Өзгерістер',
    'policy.tt.changes.h2': 'Шарттарды өзгерту тәртібі',
    'policy.tt.changes.p1': 'Компания осы Пайдалану шарттарын кез келген уақытта өзгерту құқығын өзіне қалдырады. Маңызды өзгерістер болған жағдайда:',
    'policy.tt.changes.l1': 'Сайтта хабарландыру жарияланады',
    'policy.tt.changes.l2': 'Соңғы жаңарту күні жаңартылады',
    'policy.tt.changes.l3': 'Тіркелген пайдаланушыларға email хабарлама жіберіледі',
    'policy.tt.changes.p2': 'Сайтты жаңартылған шарттардан кейін де пайдалану жалғастырсаңыз, жаңа шарттарды қабылдаған болып саналасыз.',
    'policy.tt.law.label': 'Заңнама',
    'policy.tt.law.h2': 'Қолданылатын заңнама',
    'policy.tt.law.p1': 'Осы Шарттар Қазақстан Республикасының заңнамасына сәйкес реттеледі. Кез келген дау немесе келіспеушілік Алматы қаласының соттарында қаралады.',
    'policy.tt.law.h4': 'Заңдық сұрақтар бойынша байланыс',

    // The four static pages' own head, shared by the component and the build-time
    // prerenderer through `STATIC_PAGES` — one description, so the two cannot drift.
    'booking.page.title': 'Консультацияға жазылу — Ипотекалық дәрігер',
    'booking.page.desc': 'Тегін ипотекалық консультацияға ыңғайлы уақытты онлайн таңдаңыз.',
    'blog.page.title': 'Посттар — Ипотекалық дәрігер',
    'blog.page.desc': 'Ипотека туралы мақалалар: бағдарламалар, құжаттар және сарапшы кеңестері.',
};
